import { primaryColor } from '~/colors'

export default {
    print: {
        display: 'flex',
        alignItems: 'center',
        color: primaryColor,
        fontSize: 12,
        fontWeight: '400'
    },
    icon: {
        color: primaryColor,
        width: 14
    }
}



// WEBPACK FOOTER //
// ./src/views/Products/ProductSummary/ProductSummaryContent/styles.js